module.exports = __webpack_public_path__ + "static/media/blackWhiteSkirt.64895794.jpg";